import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface GiftHeaderProps {
  isGift?: boolean;
  title?: string;
  onBack?: () => void;
  showBackButton?: boolean;
}

export const GiftHeader = ({ isGift, title = "Subscription", onBack, showBackButton = true }: GiftHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (isGift) {
      // Navigate back to gift subscription page
      navigate('/gift-subscription');
    } else if (onBack) {
      // Use provided onBack handler
      onBack();
    } else {
      // Default back navigation
      navigate(-1);
    }
  };

  return (
    <div className="sticky top-0 z-10 bg-white p-4 border-b border-gray-100">
      <div className="flex items-center">
        {showBackButton && (
          <button 
            onClick={handleBack} 
            className="mr-2 p-1 rounded-full hover:bg-gray-100"
            aria-label="Go back"
          >
            <ArrowLeft size={20} />
          </button>
        )}
        <h1 className="text-lg font-semibold">{title}</h1>
      </div>
    </div>
  );
};

export default GiftHeader; 